export const COLOUR_PICKER_X = 820;
export const COLOUR_PICKER_Y = 20;
export const COLOUR_PICKER_WIDTH = 180;
export const COLOUR_PICKER_HEIGHT = 180;
